module.exports = __webpack_public_path__ + "img/zuixinruzhu_bg.ec37463e.png";